
// to move an item to the end of the list will return toId=undefined
export function getMoveIds(fromIndex, toIndex, places) {
  const movingFromAbove = (fromIndex < toIndex)
  const fromNode = places[fromIndex]
  const toNode = places[toIndex] // could be undefined if past end of list
  const fromId = fromNode.id
  const toId = toNode.id
  return [fromId, toId, movingFromAbove]
}
